/**
 * テキストからファセット（メンション、URL、ハッシュタグ）を検出
 * 注: 現在は簡易実装。完全な実装には@atproto/apiのagentが必要
 */
export const detectFacets = async (_text: string): Promise<any[]> => {
  try {
    // 簡易版: 今後実装予定
    return [];
  } catch (error) {
    console.error('Detect facets error:', error);
    return [];
  }
};

/**
 * メンションを検出
 */
export const detectMentions = (text: string): string[] => {
  const mentionRegex = /@([a-zA-Z0-9][a-zA-Z0-9.-]*[a-zA-Z0-9])/g;
  const matches = text.match(mentionRegex);
  return matches ? matches.map(m => m.substring(1)) : [];
};

/**
 * ハッシュタグを検出
 */
export const detectHashtags = (text: string): string[] => {
  const hashtagRegex = /#([^\s!@#$%^&*(),.?":{}|<>]+)/g;
  const matches = text.match(hashtagRegex);
  return matches ? matches.map(m => m.substring(1)) : [];
};

/**
 * URLを検出
 */
export const detectUrls = (text: string): string[] => {
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  const matches = text.match(urlRegex);
  return matches || [];
};

/**
 * 文字数をカウント
 */
export const countGraphemes = (text: string): number => {
  // シンプルな文字数カウント
  // より正確にはgrapheme-splitter等のライブラリを使用
  return text.length;
};
